<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">
            <form *ngIf="setPermissionsForm" [formGroup]="setPermissionsForm" (ngSubmit)="submitForm()">
                <div class="card-header">
                    <div class="row align-items-center select2-container" *ngIf="checkViewPermission else defaultBlock">
                        <div class="col-md-6">
                            <h4 class="card-title">Roles & Permissions</h4>
                        </div>
                        <div class="col-md-6 text-end" *ngIf="checkUpdatePermission">
                            <button class="btn btn-primary" type="submit" [disabled]="setPermissionsForm.invalid">Save</button>
                        </div>
                    </div>
                    <ng-template #defaultBlock>
                        <div class="row w-100">
                            <div class="col-md-12">
                            <h4 class="card-title text-center"> {{ noPermission }}</h4>
                        </div>
                        </div>
                    </ng-template>
                </div>

                <div class="card-body" *ngIf="checkViewPermission">                    

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">User Type<span class="text-danger">*</span></label>                        
                            <select class="form-select" formControlName="role" (change)="getRolePermissions()">
                                <option value="" selected disabled>Please select</option>
                                <option value="super_admin">Super Admin</option>
                                <option value="partner_admin">Partner Admin</option>
                                <option value="property_manager">Property Manager</option>
                                <option value="maintance_manager">Maintenance Manager</option>
                                <option value="tele_caller">Telecaller</option>
                                <option value="vendor">Vendor</option>
                                <option value="tenant">Tenant</option>
                                <option value="owner">Owner</option>
                            </select>
                            <div *ngIf="setPermissionsForm?.get('role')?.invalid && setPermissionsForm?.get('role')?.touched" class="required">
                                Select user role
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Permissions</label>
                        <input type="text" class="form-control" placeholder="Search for permission" formControlName="searchText" (input)="filterItems()" autocomplete="off">
                      </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <label class="form-label mb-3">Select Permissions</label>
                        <div class="row" formArrayName="selectedPermissions">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let permission of filteredItems; let i= index">
                                <div class="form-check custom-checkbox mb-2">
                                    <input type="checkbox" class="form-check-input" [id]="permission.uid" [formControlName]="i">
                                    <label class="form-check-label" [for]="permission.uid">{{permission.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="setPermissionsForm?.get('selectedPermissions')?.invalid && setPermissionsForm?.get('selectedPermissions')?.touched" class="required">
                            At least one checkbox must be selected.
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
